// CSE (Colombo Stock Exchange) — TradingView Symbol Mapping
// Format: "TICKER.BOARD": "CSELK:TICKER.BOARD0000"
// Board suffixes:
//   .N  → Main Board          → N0000
//   .X  → Diri Savi Board     → X0000
//   .D  → Debt Securities     → D0000
//   .W  → Warrants            → W0000
//   .R  → Rights              → R0000
//   .U  → Unit Trusts         → U0000
//   .P  → Preference Shares   → P0000

export const CSE_SYMBOLS: Record<string, string> = {
  // Manufacturing & Industry
  "ACL.N": "CSELK:ACL.N0000",
  "TILE.N": "CSELK:TILE.N0000",
  "LWL.N": "CSELK:LWL.N0000",
  "RCL.N": "CSELK:RCL.N0000",
  "TYRE.N": "CSELK:TYRE.N0000",
  "DIPD.N": "CSELK:DIPD.N0000",
  "GLAS.N": "CSELK:GLAS.N0000",
  "HAYC.N": "CSELK:HAYC.N0000",
  "JAT.N": "CSELK:JAT.N0000",
  "BLUE.N": "CSELK:BLUE.N0000",
  "CERA.N": "CSELK:CERA.N0000",
  "CHMX.N": "CSELK:CHMX.N0000",
  "CIND.N": "CSELK:CIND.N0000",
  "DPL.N": "CSELK:DPL.N0000",
  "VLL.N": "CSELK:VLL.N0000",
  "HHL.N": "CSELK:HHL.N0000",
  "RICH.N": "CSELK:RICH.N0000",
  "SUN.N": "CSELK:SUN.N0000",
  "VPEL.N": "CSELK:VPEL.N0000",
  "NAMU.N": "CSELK:NAMU.N0000",
  "ELPL.N": "CSELK:ELPL.N0000",
  "WATA.N": "CSELK:WATA.N0000",
  "AGAL.N": "CSELK:AGAL.N0000",
  "SIRA.N": "CSELK:SIRA.N0000",
  "LALU.N": "CSELK:LALU.N0000",
  "KCAB.N": "CSELK:KCAB.N0000",
  "TKYO.N": "CSELK:TKYO.N0000",
  "APLA.N": "CSELK:APLA.N0000",
  "LLUB.N": "CSELK:LLUB.N0000",
  "BOGA.N": "CSELK:BOGA.N0000",
  "EXPO.N": "CSELK:EXPO.N0000",
  "MGT.N": "CSELK:MGT.N0000",
  "HEXP.N": "CSELK:HEXP.N0000",
  "HELA.N": "CSELK:HELA.N0000",
  "RGEM.N": "CSELK:RGEM.N0000",
  "TJL.N": "CSELK:TJL.N0000",
  "ALUF.N": "CSELK:ALUF.N0000",
  "EML.N": "CSELK:EML.N0000",
  "EXT.N": "CSELK:EXT.N0000",
  "BPPL.N": "CSELK:BPPL.N0000",
  "ALUM.N": "CSELK:ALUM.N0000",
  "PACK.N": "CSELK:PACK.N0000",
  "WIND.N": "CSELK:WIND.N0000",
  "ACME.N": "CSELK:ACME.N0000",

  // Banking
  "ABL.N": "CSELK:ABL.N0000",
  "COMB.N": "CSELK:COMB.N0000",
  "DFCC.N": "CSELK:DFCC.N0000",
  "HNB.N": "CSELK:HNB.N0000",
  "NDB.N": "CSELK:NDB.N0000",
  "NTB.N": "CSELK:NTB.N0000",
  "PABC.N": "CSELK:PABC.N0000",
  "SAMP.N": "CSELK:SAMP.N0000",
  "SDB.N": "CSELK:SDB.N0000",
  "SEYB.N": "CSELK:SEYB.N0000",
  "UBC.N": "CSELK:UBC.N0000",
  "CBNK.N": "CSELK:CBNK.N0000",
  "BOC.D": "CSELK:BOC.D0000",

  // Beverage, Food & Tobacco
  "BREW.N": "CSELK:BREW.N0000",
  "DIST.N": "CSELK:DIST.N0000",
  "LION.N": "CSELK:LION.N0000",
  "MELS.N": "CSELK:MELS.N0000",
  "SOY.N": "CSELK:SOY.N0000",
  "GRAN.N": "CSELK:GRAN.N0000",
  "CTEA.N": "CSELK:CTEA.N0000",
  "HARI.N": "CSELK:HARI.N0000",
  "HVA.N": "CSELK:HVA.N0000",
  "KFP.N": "CSELK:KFP.N0000",
  "KOTA.N": "CSELK:KOTA.N0000",
  "LAMB.N": "CSELK:LAMB.N0000",
  "LMF.N": "CSELK:LMF.N0000",
  "MAL.N": "CSELK:MAL.N0000",
  "MASK.N": "CSELK:MASK.N0000",
  "NEST.N": "CSELK:NEST.N0000",
  "RWSL.N": "CSELK:RWSL.N0000",
  "RAL.N": "CSELK:RAL.N0000",
  "COCO.N": "CSELK:COCO.N0000",
  "TPL.N": "CSELK:TPL.N0000",
  "TSML.N": "CSELK:TSML.N0000",
  "TAFL.N": "CSELK:TAFL.N0000",
  "UDPL.N": "CSELK:UDPL.N0000",
  "TESS.N": "CSELK:TESS.N0000",
  "SWAD.N": "CSELK:SWAD.N0000",

  // Chemicals & Pharmaceuticals
  "CCS.N": "CSELK:CCS.N0000",
  "ASIY.N": "CSELK:ASIY.N0000",
  "CALT.N": "CSELK:CALT.N0000",
  "FCT.N": "CSELK:FCT.N0000",
  "ASPH.N": "CSELK:ASPH.N0000",
  "PHAR.N": "CSELK:PHAR.N0000",
  "CARE.N": "CSELK:CARE.N0000",

  // Construction & Engineering
  "REXP.N": "CSELK:REXP.N0000",
  "UCAR.N": "CSELK:UCAR.N0000",
  "DOCK.N": "CSELK:DOCK.N0000",
  "DOCK.R": "CSELK:DOCK.R0000",

  // Conglomerates / Diversified Holdings
  "AGST.N": "CSELK:AGST.N0000",
  "CIC.N": "CSELK:CIC.N0000",
  "TAP.N": "CSELK:TAP.N0000",
  "ASHO.N": "CSELK:ASHO.N0000",
  "SPEN.N": "CSELK:SPEN.N0000",
  "EBCR.N": "CSELK:EBCR.N0000",
  "HAYL.N": "CSELK:HAYL.N0000",
  "JKH.N": "CSELK:JKH.N0000",
  "LCEY.N": "CSELK:LCEY.N0000",
  "RHL.N": "CSELK:RHL.N0000",
  "CFLB.N": "CSELK:CFLB.N0000",
  "VONE.N": "CSELK:VONE.N0000",
  "LITE.N": "CSELK:LITE.N0000",
  "MEL.N": "CSELK:MEL.N0000",
  "AEL.N": "CSELK:AEL.N0000",
  "LUMX.N": "CSELK:LUMX.N0000",
  "INDU.N": "CSELK:INDU.N0000",

  // Plantation
  "BALA.N": "CSELK:BALA.N0000",
  "BOPL.N": "CSELK:BOPL.N0000",
  "BUKI.N": "CSELK:BUKI.N0000",
  "HPL.N": "CSELK:HPL.N0000",
  "HAPU.N": "CSELK:HAPU.N0000",
  "HOPL.N": "CSELK:HOPL.N0000",
  "KAHA.N": "CSELK:KAHA.N0000",
  "KGAL.N": "CSELK:KGAL.N0000",
  "KVAL.N": "CSELK:KVAL.N0000",
  "LDEV.N": "CSELK:LDEV.N0000",
  "MADU.N": "CSELK:MADU.N0000",
  "MCPL.N": "CSELK:MCPL.N0000",

  // Finance & Leasing
  "AFSL.N": "CSELK:AFSL.N0000",
  "ALLI.N": "CSELK:ALLI.N0000",
  "AMF.N": "CSELK:AMF.N0000",
  "AAF.N": "CSELK:AAF.N0000",
  "CFIN.N": "CSELK:CFIN.N0000",
  "CDB.N": "CSELK:CDB.N0000",
  "COCR.N": "CSELK:COCR.N0000",
  "CALF.N": "CSELK:CALF.N0000",
  "HNBF.N": "CSELK:HNBF.N0000",
  "HDFC.N": "CSELK:HDFC.N0000",
  "LCBF.N": "CSELK:LCBF.N0000",
  "LFIN.N": "CSELK:LFIN.N0000",
  "NIFL.N": "CSELK:NIFL.N0000",
  "LOFC.N": "CSELK:LOFC.N0000",
  "LOLC.N": "CSELK:LOLC.N0000",
  "MBSL.N": "CSELK:MBSL.N0000",
  "CSF.N": "CSELK:CSF.N0000",
  "BFN.N": "CSELK:BFN.N0000",
  "PLC.N": "CSELK:PLC.N0000",
  "PMB.N": "CSELK:PMB.N0000",
  "SDF.N": "CSELK:SDF.N0000",
  "SFCL.N": "CSELK:SFCL.N0000",
  "SFIN.N": "CSELK:SFIN.N0000",
  "SEMB.N": "CSELK:SEMB.N0000",
  "CRL.N": "CSELK:CRL.N0000",
  "VFIN.N": "CSELK:VFIN.N0000",
  "BFL.N": "CSELK:BFL.N0000",
  "UBF.N": "CSELK:UBF.N0000",
  "CFVF.N": "CSELK:CFVF.N0000",
  "MFPE.N": "CSELK:MFPE.N0000",
  "MFL.N": "CSELK:MFL.N0000",

  // Healthcare
  "ABAN.N": "CSELK:ABAN.N0000",
  "REG.N": "CSELK:REG.N0000",
  "SINI.N": "CSELK:SINI.N0000",
  "LPL.N": "CSELK:LPL.N0000",
  "HPFL.N": "CSELK:HPFL.N0000",
  "LVEF.N": "CSELK:LVEF.N0000",
  "PAP.N": "CSELK:PAP.N0000",

  // Power & Energy
  "HPWR.N": "CSELK:HPWR.N0000",
  "MULL.N": "CSELK:MULL.N0000",
  "ECL.N": "CSELK:ECL.N0000",
  "KDL.N": "CSELK:KDL.N0000",
  "LIOC.N": "CSELK:LIOC.N0000",
  CEB: "CSELK:CEB",

  // Information Technology & Telecom
  "ASIR.N": "CSELK:ASIR.N0000",
  "AMSL.N": "CSELK:AMSL.N0000",
  "DIAL.N": "CSELK:DIAL.N0000",
  "SLTL.N": "CSELK:SLTL.N0000",
  "CTC.N": "CSELK:CTC.N0000",
  "LPRT.N": "CSELK:LPRT.N0000",

  // Hotels & Travel
  "NHL.N": "CSELK:NHL.N0000",
  "SINH.N": "CSELK:SINH.N0000",
  "LHCL.N": "CSELK:LHCL.N0000",
  "AHUN.N": "CSELK:AHUN.N0000",
  "ACAP.N": "CSELK:ACAP.N0000",
  "AHPL.N": "CSELK:AHPL.N0000",
  "BRR.N": "CSELK:BRR.N0000",
  "BERU.N": "CSELK:BERU.N0000",
  "BBH.N": "CSELK:BBH.N0000",
  "CHOT.N": "CSELK:CHOT.N0000",
  "REEF.N": "CSELK:REEF.N0000",
  "STAF.N": "CSELK:STAF.N0000",
  "EDEN.N": "CSELK:EDEN.N0000",
  "GHLL.N": "CSELK:GHLL.N0000",
  "CONN.N": "CSELK:CONN.N0000",
  "CITH.N": "CSELK:CITH.N0000",
  "HSIG.N": "CSELK:HSIG.N0000",
  "JETS.N": "CSELK:JETS.N0000",
  "KHL.N": "CSELK:KHL.N0000",
  "MRH.N": "CSELK:MRH.N0000",
  "MARA.N": "CSELK:MARA.N0000",
  "PALM.N": "CSELK:PALM.N0000",
  "PEG.N": "CSELK:PEG.N0000",
  "RENU.N": "CSELK:RENU.N0000",
  "RFL.N": "CSELK:RFL.N0000",
  "RCH.N": "CSELK:RCH.N0000",
  "RPBH.N": "CSELK:RPBH.N0000",
  "SHOT.N": "CSELK:SHOT.N0000",
  "SIGV.N": "CSELK:SIGV.N0000",
  "TAJ.N": "CSELK:TAJ.N0000",
  "TANG.N": "CSELK:TANG.N0000",
  "RHTL.N": "CSELK:RHTL.N0000",
  "KHC.N": "CSELK:KHC.N0000",
  "SERV.N": "CSELK:SERV.N0000",
  "LHL.N": "CSELK:LHL.N0000",
  "NEH.N": "CSELK:NEH.N0000",
  "CITW.N": "CSELK:CITW.N0000",
  "SHL.N": "CSELK:SHL.N0000",
  "SING.N": "CSELK:SING.N0000",
  "CALH.N": "CSELK:CALH.N0000",
  "CHL.N": "CSELK:CHL.N0000",

  // Insurance
  "ATL.N": "CSELK:ATL.N0000",
  "CINS.N": "CSELK:CINS.N0000",
  "COOP.N": "CSELK:COOP.N0000",
  "HASU.N": "CSELK:HASU.N0000",
  "AAIC.N": "CSELK:AAIC.N0000",
  "ATLL.N": "CSELK:ATLL.N0000",
  "AINS.N": "CSELK:AINS.N0000",
  "JINS.N": "CSELK:JINS.N0000",
  "SCAP.N": "CSELK:SCAP.N0000",
  "UAL.N": "CSELK:UAL.N0000",
  "LGIL.N": "CSELK:LGIL.N0000",
  "PINS.N": "CSELK:PINS.N0000",
  "CINV.N": "CSELK:CINV.N0000",
  "GUAR.N": "CSELK:GUAR.N0000",
  "CFI.N": "CSELK:CFI.N0000",

  // Investment Trusts & Funds
  "WAPO.N": "CSELK:WAPO.N0000",
  "GOOD.N": "CSELK:GOOD.N0000",
  "LVEN.N": "CSELK:LVEN.N0000",
  "KZOO.N": "CSELK:KZOO.N0000",
  "SELI.N": "CSELK:SELI.N0000",
  "PARQ.N": "CSELK:PARQ.N0000",
  "GEST.N": "CSELK:GEST.N0000",

  // Land & Property
  "LGL.N": "CSELK:LGL.N0000",
  "COMD.N": "CSELK:COMD.N0000",
  "SHAW.N": "CSELK:SHAW.N0000",
  "MHDL.N": "CSELK:MHDL.N0000",
  "MDL.N": "CSELK:MDL.N0000",
  "OSEA.N": "CSELK:OSEA.N0000",
  "PLR.N": "CSELK:PLR.N0000",
  "CABO.N": "CSELK:CABO.N0000",

  // Motor
  "DIMO.N": "CSELK:DIMO.N0000",
  "SMOT.N": "CSELK:SMOT.N0000",
  "UML.N": "CSELK:UML.N0000",
  "CARS.N": "CSELK:CARS.N0000",
  "AUTO.N": "CSELK:AUTO.N0000",

  // Oil Palms
  "BIL.N": "CSELK:BIL.N0000",

  // Services & Trading
  "BRWN.N": "CSELK:BRWN.N0000",
  "CWM.N": "CSELK:CWM.N0000",
  "CTBL.N": "CSELK:CTBL.N0000",
  "EMER.N": "CSELK:EMER.N0000",
  "HUNT.N": "CSELK:HUNT.N0000",
  "JKL.N": "CSELK:JKL.N0000",
  "SINS.N": "CSELK:SINS.N0000",
  "RIL.N": "CSELK:RIL.N0000",
  "CTHR.N": "CSELK:CTHR.N0000",
  "CARG.N": "CSELK:CARG.N0000",
  "KPHL.N": "CSELK:KPHL.N0000",
  "ODEL.N": "CSELK:ODEL.N0000",
  "HBS.N": "CSELK:HBS.N0000",
  "CWL.N": "CSELK:CWL.N0000",
  "AGPL.N": "CSELK:AGPL.N0000",
  "AFS.N": "CSELK:AFS.N0000",
  "CLND.N": "CSELK:CLND.N0000",
  "CTLD.N": "CSELK:CTLD.N0000",
  "EAST.N": "CSELK:EAST.N0000",
  "ETWO.N": "CSELK:ETWO.N0000",
  "ASCO.N": "CSELK:ASCO.N0000",
  "MSL.N": "CSELK:MSL.N0000",
  "ONAL.N": "CSELK:ONAL.N0000",
  "SLND.N": "CSELK:SLND.N0000",
  "CSD.N": "CSELK:CSD.N0000",
  "YORK.N": "CSELK:YORK.N0000",
  "COLO.N": "CSELK:COLO.N0000",
  "AMCL.N": "CSELK:AMCL.N0000",
  "BLI.N": "CSELK:BLI.N0000",
  "CHOU.N": "CSELK:CHOU.N0000",
  "IDL.N": "CSELK:IDL.N0000",
  "CPRT.N": "CSELK:CPRT.N0000",
  "GREG.N": "CSELK:GREG.N0000",
  "WLTH.N": "CSELK:WLTH.N0000",
  "INME.N": "CSELK:INME.N0000",
  "JFP.N": "CSELK:JFP.N0000",
  "CSLK.N": "CSELK:CSLK.N0000",
  "CIT.N": "CSELK:CIT.N0000",
  "PKME.N": "CSELK:PKME.N0000",
  "HUNA.N": "CSELK:HUNA.N0000",
  "PARA.N": "CSELK:PARA.N0000",
  "SIL.N": "CSELK:SIL.N0000",
  "TRAN.N": "CSELK:TRAN.N0000",
  "OFEQ.N": "CSELK:OFEQ.N0000",
  "MERC.N": "CSELK:MERC.N0000",
  "ALHP.N": "CSELK:ALHP.N0000",
  "SHAL.N": "CSELK:SHAL.N0000",
  "ASPM.N": "CSELK:ASPM.N0000",

  // Diri Savi Board (.X)
  "BLUE.X": "CSELK:BLUE.X0000",
  "CIC.X": "CSELK:CIC.X0000",
  "CINS.X": "CSELK:CINS.X0000",
  "CDB.X": "CSELK:CDB.X0000",
  "COMB.X": "CSELK:COMB.X0000",
  "HNB.X": "CSELK:HNB.X0000",
  "HNBF.X": "CSELK:HNBF.X0000",
  "LGL.X": "CSELK:LGL.X0000",
  "MAL.X": "CSELK:MAL.X0000",
  "NTB.X": "CSELK:NTB.X0000",
  "COCO.X": "CSELK:COCO.X0000",
  "RHL.X": "CSELK:RHL.X0000",
  "SHOT.X": "CSELK:SHOT.X0000",
  "SEYB.X": "CSELK:SEYB.X0000",
  "SEMB.X": "CSELK:SEMB.X0000",
  "TESS.X": "CSELK:TESS.X0000",
  "TKYO.X": "CSELK:TKYO.X0000",
  "VLL.X": "CSELK:VLL.X0000",
  "LPL.X": "CSELK:LPL.X0000",
  "AGST.X": "CSELK:AGST.X0000",
  "CHL.X": "CSELK:CHL.X0000",
  "SHL.W": "CSELK:SHL.W0000",
  "FFL.D": "CSELK:FFL.D0000",
  "ABNS.D": "CSELK:ABNS.D0000",

  // Unit Trusts (.U)
  "NAVF.U": "CSELK:NAVF.U0000",
  "CALI.U": "CSELK:CALI.U0000",
  "CALC.U": "CSELK:CALC.U0000",
  "AAF.P": "CSELK:AAF.P0000",
  SLFL: "CSELK:SLFL",
  SIC: "CSELK:SIC",
};

// Helper: get TradingView symbol from CSE ticker
export function getTVSymbol(cseTicker: string): string {
  return CSE_SYMBOLS[cseTicker] ?? `CSELK:${cseTicker}`;
}

// Helper: get all TradingView symbols as a flat array
export function getAllTVSymbols(): string[] {
  return Object.values(CSE_SYMBOLS);
}

// Helper: get all CSE tickers as a flat array
export function getAllCSETickers(): string[] {
  return Object.keys(CSE_SYMBOLS);
}
